(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const syncResponsiveImages = () => {
    document.querySelectorAll('[data-carousel] .bijumi-home__carousel-image').forEach((image) => {
      const carousel = image.closest('[data-carousel]');
      const isMobileCarousel = carousel?.dataset.carousel.includes('mobile');
      const shouldLoad = isMobileCarousel === mobileQuery.matches;
      if (shouldLoad && image.dataset.carouselSrc && image.src !== image.dataset.carouselSrc) {
        image.src = image.dataset.carouselSrc;
      }
      if (!shouldLoad && image.src !== 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==') {
        image.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }
    });
  };
  syncResponsiveImages();
  mobileQuery.addEventListener?.('change', syncResponsiveImages);

  const carousels = document.querySelectorAll('[data-carousel]');
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('.bijumi-home__carousel-slide')];
    const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
    if (slides.length < 2) return;

    const isHero = carousel.dataset.carousel === 'hero';

    let activeIndex = 0;
    let timer;
    let touchStartX = 0;

    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === activeIndex));
      if (isHero) carousel.classList.toggle('is-transitioning', true);
      dots.forEach((dot, i) => {
        const active = i === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (isHero) window.setTimeout(() => carousel.classList.remove('is-transitioning'), 750);
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      timer = window.setInterval(() => show(activeIndex + 1), Number(carousel.dataset.interval) || 5000);
    };

    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.carouselDot));
      start();
    }));

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    carousel.addEventListener('touchstart', stop, { passive: true });
    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || touchStartX;
      const deltaX = touchEndX - touchStartX;
      if (Math.abs(deltaX) > 36) show(activeIndex + (deltaX < 0 ? 1 : -1));
      start();
    }, { passive: true });
    start();
  });
})();
